






























import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component,
} from 'vue-property-decorator';
import {
  Alert,
  NoticeClass,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import DisclaimerFooter from '@/components/DisclaimerFooter.vue';
import QuestionCard from '@/components/QuestionCard.vue';
import AnswerSummary from '@/components/AnswerSummary.vue';


@Component({
  computed: mapState(['fiId', 'graphMap', 'fiSettings', 'auth', 'stringMap', 'isAdminUser']),
  components: {
    DisclaimerFooter, QuestionCard, AnswerSummary, KCardHeader,
  },
})
export default class ReportsView extends Vue {
  fiId!: string;

  isAdminUser!: boolean;

  headerItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: 'Usage Report',
      disabled: true,
    },
  ];


  showErrorMessage(error: any) {
    console.error(error);
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  downloadGlobalReport = () => {
    window.location.href = '/api/report/';
  }

  downloadFiReport() {
    window.location.href = `/api/report/${this.fiId}`;
  }
}
